import React, { useEffect, useState } from "react";
import axios from "axios";
import FlightForm from "../components/FlightForm";
import { format } from "date-fns";
import Modal from "./Modal";

const FlightsModal = ({ isOpen, onClose, tripId }) => {
  const [flights, setFlights] = useState([]);
  const [editingFlight, setEditingFlight] = useState(null);
  const [isAdding, setIsAdding] = useState(false);

  useEffect(() => {
    if (isOpen && tripId) {
      loadFlights();
    }
  }, [isOpen, tripId]);

  const loadFlights = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/subtripitems/trip/${tripId}/flights`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      setFlights(res.data);
    } catch (error) {
      console.error("Failed to load flights", error);
    }
  };

  const handleDeleteFlight = async (flightId) => {
    if (!window.confirm("Are you sure you want to delete this flight?")) return;

    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/subtripitems/flight/${flightId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      loadFlights();
    } catch (error) {
      console.error("Failed to delete flight", error);
    }
  };

  const handleCloseForm = () => {
    setEditingFlight(null);
    setIsAdding(false);
    loadFlights();
  };

  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="w-full max-w-md sm:max-w-3xl max-h-[80vh] overflow-y-auto px-4 sm:px-6 py-4">
        <h2 className="text-lg sm:text-xl font-bold text-primary mb-4 text-center sm:text-left">Flights</h2>

        {/* Add Flight */}
        <button
          className="mb-4 w-full sm:w-auto px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
          onClick={() => {
            setIsAdding(true);
            setEditingFlight(null);
          }}
        >
          + Add Flight
        </button>

        {/* Flight List */}
        <ul className="space-y-4">
          {flights.map((flight) => (
            <li
              key={flight.id}
              className="border border-gray-300 p-4 rounded hover:bg-gray-50 relative cursor-pointer"
              onClick={() => {
                setEditingFlight(flight);
                setIsAdding(false);
              }}
            >
              <button
                className="absolute top-2 right-2 text-red-500 hover:text-red-700"
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteFlight(flight.id);
                }}
              >
                ✕
              </button>
              <div className="font-semibold">{flight.flight_number}</div>
              <div className="text-sm text-gray-600">
                {flight.depart_airport_code} ➔ {flight.arrive_airport_code}
              </div>
              <div className="text-sm text-gray-500">
                {format(new Date(flight.depart_date), "yyyy-MM-dd HH:mm")} -{" "}
                {format(new Date(flight.arrive_date), "yyyy-MM-dd HH:mm")}
              </div>
              {flight.notes && (
                <div className="text-sm text-gray-700 mt-1">{flight.notes}</div>
              )}
            </li>
          ))}
        </ul>
      </div>

      {(editingFlight || isAdding) && (
        <FlightForm
          tripId={tripId}
          existingData={editingFlight}
          onFlightAdded={handleCloseForm}
          onClose={handleCloseForm}
        />
      )}
    </Modal>
  );
};

export default FlightsModal;
